<sn-mobile-phone-control
  [id]="id"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [tabindex]="templateOptions.tabindex || 0"
  [placeholder]="templateOptions.placeholder"
>
</sn-mobile-phone-control>
